<template>
	<div class></div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				linkQuery: {
					path: "/",
				},
			};
		},
		created() {
			// if (this.$route.query) {
			// 	this.linkQuery = this.$route.query;
			// }
			var token = localStorage.getItem("token");
			var tokenTime = localStorage.getItem("tokenTime") * 1000;
			var day = new Date().getTime();
			if (!token || token === null) {
				this.$get("token").then((res) => {
					// //console.log(res);
					localStorage.setItem("token", res.data.token);
					localStorage.setItem("tokenTime", res.data.last_time);
				});
			}
			setTimeout(() => {
				this.$router.replace({
					path: this.linkQuery.path,
				});
			}, 100);
		},
	};
</script>

<style scoped>
</style>
